/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getSdk, RelatedProductsQuery } from "services/datocms/generated";
import { createDatoClient } from "services/datocms";
import CollectionItem from "components/CollectionItem";

const RockstarRelatedProducts = () => {
  const router = useRouter();
  const [relatedProducts, setRelatedProducts] = useState<
    NonNullable<RelatedProductsQuery["featuredProduct"]>["products"]
  >([]);
  useEffect(() => {
    getSdk(createDatoClient(router?.isPreview))
      .RelatedProducts()
      .then((res) => {
        setRelatedProducts(res?.featuredProduct?.products || []);
      });
  }, [router?.isPreview]);

  return (
    <div className="container" style={{ marginTop: 50 }}>
      <div className="rockstar-related-products">
        <h2 className="related-title">FUEL YOUR GRIND</h2>
        <ul className="rockstar-products">
          {relatedProducts?.map((product) => (
            <CollectionItem
              key={product?.id}
              slug={product?.slug || ""}
              image={product?.productImages?.[0].url || ""}
              title={product.title || ""}
              nutritionLink={product?.nutritionLink || ""}
              flavorName={product?.flavorName || ""}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RockstarRelatedProducts;
